import React from 'react';
import AsyncPage from './async';
import {Route, Navigate} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import AsyncThankPage from '../contactsales/thankyou/async';
import BlankLayout from '../../../../components/layout/BlankLayout';
import ContactSalesAsync from '../contactsales/async';

export default [
  <Route
    key="/business/contact-us"
    path="business/contact-us"
    element={<Navigate to="../business/contact-us/sales" replace />}
  />,
  <Route
    key="/business/contact-us"
    path="business/contact-us/:type?"
    element={<AsyncPage />}
  />,
  <Route
    key="/business/contact-sales/:thankyou"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Thank you',
            item: '/business/contact-sales/thankyou',
          },
        ]}
        showContactSales={false}
      />
    }
  >
    <Route path="business/contact-sales/thank-you" element={<AsyncThankPage />} />
  </Route>,
  <Route
    key="/business/contact-sales"
    element={
      <BlankLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Contact Sales',
            item: '/business/contact-sales',
          },
        ]}
        showContactSales={false}
      />
    }
  >
    <Route path="business/contact-sales" element={<ContactSalesAsync />} />
  </Route>,
];
